import styled from "styled-components";
import { colors } from "../../../utils/styled/_variables.styled";

export const Input = styled.input`
  width: 16px;
  height: 16px;
  accent-color: ${colors.greenLight};
`;

export const Container = styled.div`
  display: flex;
  gap: 8px;
  align-items: center;
`;

export const Label = styled.label`
  p {
    font-size: 16px;
    font-weight: 400;
    line-height: 20px;
    color: ${colors.gray1};
  }
  a {
    color: ${colors.greenLight};
  }
`;

export const ErrorMessage = styled.p`
  font-size: 16px;
  color: ${colors.red};
`;